<!-- 


<form>
    <div class="card text-center">
      <div class="card-header bg-primary text-left text-white font-weight-bold">
        SPRA Dashboard
      </div>
      <div class="card-body mat-card"> -->

        <!-- width="100%"    height="100vh" -->
        <iframe   
         src="http://acsmetabase.centralindia.azurecontainer.io:3000/public/dashboard/e93e159a-ea09-4633-ad61-c93b487c2fcf" 
         frameborder="0"
         width="100%"
         class="iframe-dashboard"
         height="2200"
         allowtransparency>
        </iframe>  
  
      <!-- </div>
    </div>
  </form> -->